import { render, staticRenderFns } from "./charge-shipping-etc-cost.vue?vue&type=template&id=068372ce"
import script from "./charge-shipping-etc-cost.vue?vue&type=script&lang=js"
export * from "./charge-shipping-etc-cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports